import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'miq-collapse-all',
  templateUrl: './collapse-all.component.html',
  styleUrls: ['./collapse-all.component.scss'],
  standalone: false,
})
export class CollapseAllComponent {
  @Input() collapseLabel: string;
  @Input() expandLabel: string;
  @Input() disabled: boolean = false;
  @Input()
  get isCollapsed(): boolean {
    return this._isCollapsed;
  }
  set isCollapsed(isCollapsed: boolean) {
    if (isCollapsed != null) {
      this._isCollapsed = isCollapsed;
      this.setIconAndLabel(isCollapsed);
    }
  }
  @Output() onToggle = new EventEmitter();

  private iconNameMap = {
    expand: 'expand-icon',
    collapse: 'collapse-icon',
  };
  private _isCollapsed: boolean;
  public iconName = this.iconNameMap.expand;
  public iconLabel = '';

  private setIconAndLabel(isCollapsed: boolean) {
    this.iconName = isCollapsed ? this.iconNameMap.expand : this.iconNameMap.collapse;
    this.iconLabel = isCollapsed ? this.expandLabel : this.collapseLabel;
  }

  public toggle() {
    this.onToggle.emit();
  }
}
